/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */
import { installCamera } from './iacoComm';

// Cada bloque instala el código base de la cámara (ver iacoComm.js): va bajo
// claves fijas, así que se emite una sola vez y convive con IACO_buttons.

// El campo de los bloques sombra guarda el hex; la librería espera su constante.
// No se exporta: index.js registra como generador todo lo que exporta este archivo.
const CAMERA_COLOURS = {
  '#cc0000': 'CAM_ROJO',
  '#33ff33': 'CAM_VERDE',
  '#ffff00': 'CAM_AMARILLO',
  '#000099': 'CAM_AZUL',
};

// Sombras de color: devuelven directamente la constante de la librería.
const colourShadow = (block, generator) => [CAMERA_COLOURS[block.getFieldValue('COLOR')] || 'CAM_ROJO', generator.ORDER_ATOMIC];
export const CAMERA_colour = colourShadow;
export const CAMERA_colour_position = colourShadow;

const colourConstant = (block, generator) => generator.valueToCode(block, 'COLOR', generator.ORDER_ATOMIC) || 'CAM_ROJO';

export const CAMERA_face_detected = (block, generator) => {
  installCamera(generator);
  return ['cam.caraDetectada()', generator.ORDER_ATOMIC];
};

export const CAMERA_color_detected = (block, generator) => {
  installCamera(generator);
  return [`cam.colorDetectado(${colourConstant(block, generator)})`, generator.ORDER_ATOMIC];
};

export const CAMERA_shape_detected = (block, generator) => {
  installCamera(generator);
  return [`cam.formaDetectada(${block.getFieldValue('SHAPE')})`, generator.ORDER_ATOMIC];
};

export const CAMERA_motion_detected = (block, generator) => {
  installCamera(generator);
  return ['cam.movimientoDetectado()', generator.ORDER_ATOMIC];
};

export const CAMERA_color_position = (block, generator) => {
  installCamera(generator);
  return [`cam.posicionColor(${colourConstant(block, generator)}, ${block.getFieldValue('AXIS')})`, generator.ORDER_ATOMIC];
};
